import {
  Directive,
  ElementRef,
  Inject,
  Input,
  KeyValueDiffers,
  Optional,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  NGX_CURRENCY_CONFIG,
  NgxCurrencyConfig,
  NgxCurrencyDirective,
} from 'ngx-currency';

@Directive({
  selector: '[luiCurrencyMask]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyMaskDirective),
      multi: true,
    },
  ],
})
export class CurrencyMaskDirective extends NgxCurrencyDirective {
  @Input()
  public get currencyOptions(): Partial<NgxCurrencyConfig> {
    return this.options;
  }
  public set currencyOptions(value: Partial<NgxCurrencyConfig>) {
    this.options = value;
  }

  constructor(
    @Optional()
    @Inject(NGX_CURRENCY_CONFIG)
    globalOptions: Partial<NgxCurrencyConfig>,
    keyValueDiffers: KeyValueDiffers,
    readonly el: ElementRef
  ) {
    super(globalOptions, keyValueDiffers, el);
  }
}
